@if (loading || (loadingPasswordPolicy$ | async)) {
	<spinner />
} @else {
	<form data-test="confirm-password-form" novalidate [formGroup]="form">
		<fieldset class="credentials">
			<p>{{ "auth.confirmPassword" | translate }}</p>
			<pv-input
				data-test="new-password-input"
				formControlName="newPassword"
				icon="fa fa-lock"
				label="{{ 'auth.newPassword' | translate }}"
				placeholder="{{ 'auth.newPassword' | translate }}"
				type="password"
				[class.error]="hasRequiredError('newPassword') || hasPasswordPolicyError()"
			>
				@if (hasRequiredError("newPassword")) {
					<p class="errors" data-test="required-error" when="touched">
						{{ "error.required" | translate }}
					</p>
				}
			</pv-input>
			<div class="password-strength-indicator" data-test="password-strength-indicator">
				@for (check of validationChecksState; track check) {
					<div>
						<small [class.error]="!check?.active" [class.success]="check?.active">
							<i
								aria-hidden="true"
								class="fa"
								[class.fa-check-circle]="check?.active"
								[class.fa-times-circle]="!check?.active"
							></i>
							{{ "labels.error." + check?.key | translate: check }}
						</small>
					</div>
				}
			</div>
			<pv-input
				data-test="new-password-input-confirmation"
				formControlName="verifyPassword"
				icon="fa fa-lock"
				label="{{ 'auth.verifyPassword' | translate }}"
				placeholder="{{ 'auth.verifyPassword' | translate }}"
				type="password"
				[class.error]="form.hasError('passwordValidator') || hasRequiredError('verifyPassword')"
			>
				@if (hasRequiredError("verifyPassword")) {
					<p class="errors" data-test="required-error" when="touched">
						{{ "error.required" | translate }}
					</p>
				}
				@if (!hasRequiredError("verifyPassword") && form.hasError("passwordValidator")) {
					<p class="errors" data-test="invalid-match-error">
						{{ "labels.error.match" | translate }}
					</p>
				}
			</pv-input>
			<div class="button">
				<ui-button data-test="signin-button" [loading]="loadingPasswordPolicy$ | async" (action)="submit()">
					{{ "auth.signin" | translate }}
				</ui-button>
			</div>
		</fieldset>
	</form>
}
